var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemoveCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2559",
    "data-name": "Rectangle 2559",
    width: 62,
    height: 62,
    transform: "translate(1012.547 220.547)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2558",
    "data-name": "Rectangle 2558",
    width: 43.698,
    height: 46.067,
    fill: "none",
    stroke: "#ff4040",
    strokeWidth: 4
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5989",
    "data-name": "Group 5989",
    transform: "translate(-908 -401)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_329",
    "data-name": "Ellipse 329",
    cx: 52,
    cy: 52,
    r: 52,
    transform: "translate(908 401)",
    fill: "#ffdbdb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_5882",
    "data-name": "Mask Group 5882",
    transform: "translate(-83.547 201.453)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5985",
    "data-name": "Group 5985",
    transform: "translate(1020.849 227.682)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7119",
    "data-name": "Path 7119",
    d: "M31.562,3.243V34.758a3.294,3.294,0,0,1-3.294,3.294H5.831a3.294,3.294,0,0,1-3.294-3.294V3.243",
    transform: "translate(4.8 6.136)",
    fill: "none",
    stroke: "#ff4040",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_334",
    "data-name": "Line 334",
    x2: 43.698,
    transform: "translate(0 9.057)",
    fill: "none",
    stroke: "#ff4040",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_335",
    "data-name": "Line 335",
    x2: 16.067,
    transform: "translate(13.817 1.881)",
    fill: "none",
    stroke: "#ff4040",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_336",
    "data-name": "Line 336",
    y2: 18.635,
    transform: "translate(17.083 17.732)",
    fill: "none",
    stroke: "#ff4040",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_337",
    "data-name": "Line 337",
    y2: 18.635,
    transform: "translate(26.616 17.732)",
    fill: "none",
    stroke: "#ff4040",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveCart);
export default __webpack_public_path__ + "static/media/RemoveCart.975afcd75f321338847971137e45dff9.svg";
export { ForwardRef as ReactComponent };